'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _VstComponent2 = require('./VstComponent');

var _VstComponent3 = _interopRequireDefault(_VstComponent2);

var _VstHamburger = require('./VstHamburger');

var _VstHamburger2 = _interopRequireDefault(_VstHamburger);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VstHeader = function (_VstComponent) {
  _inherits(VstHeader, _VstComponent);

  function VstHeader() {
    _classCallCheck(this, VstHeader);

    var _this = _possibleConstructorReturn(this, (VstHeader.__proto__ || Object.getPrototypeOf(VstHeader)).call(this));

    _this._clickLogo = _this._clickLogo.bind(_this);
    return _this;
  }

  _createClass(VstHeader, [{
    key: '_clickLogo',
    value: function _clickLogo(e) {
      if (this.props.clickLogo) {
        this.props.clickLogo(e);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'header',
        { className: (0, _classnames2.default)(this.props.className, 'vst-header'), 'aria-hidden': 'false' },
        _react2.default.createElement(
          'div',
          { className: 'vst-left' },
          _react2.default.createElement(
            'div',
            { className: 'vst-logo' },
            _react2.default.createElement(
              'a',
              { className: 'vst-link', href: '/#/', ref: 'logo', onClick: this._clickLogo },
              _react2.default.createElement('img', { src: this.props.logo, alt: this.props.title })
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'vst-right' },
          _react2.default.createElement(
            'ul',
            { className: 'header-list' },
            this.props.children
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'vst-center' },
          this.props.clickHamburger && _react2.default.createElement(_VstHamburger2.default, { active: this.props.activeHamburger,
            clickHamburger: this.props.clickHamburger
          }),
          _react2.default.createElement(
            'span',
            null,
            this.props.title
          )
        )
      );
    }
  }]);

  return VstHeader;
}(_VstComponent3.default);

exports.default = VstHeader;


/** WEBPACK FOOTER **
 ** ./~/vstui/lib/components/VstHeader.js
 **/